import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PATH } from '@/router/PATH';
import { entryWindowForDate } from '../../../registersMeta';

/**
 * Logic behind the declaration-history table, so the component stays
 * render-only (the repo's triple pattern).
 *
 * Owns the journal drill-through: a declaration exists only once its entry has
 * been posted, so every row that has an entry can open it.
 */
export const useDeclarationHistory = () => {
    const navigate = useNavigate();

    // The Journal **tab**, scoped to the declaration's own date — the entry is
    // stamped with it, and that tab cannot widen the Books shell's window.
    const onOpenEntry = React.useCallback(
        (entryId: string, date: string) => {
            const window = entryWindowForDate(date);
            if (!window) {
                return;
            }
            navigate(
                PATH.ACCOUNTING.BOOKS.BIND_JOURNAL_FOR_ENTRY(entryId, window),
            );
        },
        [navigate],
    );

    return { onOpenEntry };
};

export type DeclarationHistoryModel = ReturnType<typeof useDeclarationHistory>;
